webpackJsonp([35783957827783],{

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.2.1
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (true) {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function decode (s) {
			return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
		}
	
		function init (converter) {
			function api() {}
	
			function set (key, value, attributes) {
				if (typeof document === 'undefined') {
					return;
				}
	
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);
	
				if (typeof attributes.expires === 'number') {
					attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
				}
	
				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
	
				try {
					var result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}
	
				value = converter.write ?
					converter.write(value, key) :
					encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
	
				key = encodeURIComponent(String(key))
					.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
					.replace(/[\(\)]/g, escape);
	
				var stringifiedAttributes = '';
				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
	
					// Considers RFC 6265 section 5.2:
					// ...
					// 3.  If the remaining unparsed-attributes contains a %x3B (";")
					//     character:
					// Consume the characters of the unparsed-attributes up to,
					// not including, the first %x3B (";") character.
					// ...
					stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
				}
	
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}
	
			function get (key, json) {
				if (typeof document === 'undefined') {
					return;
				}
	
				var jar = {};
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all.
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (!json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = decode(parts[0]);
						cookie = (converter.read || converter)(cookie, name) ||
							decode(cookie);
	
						if (json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						jar[name] = cookie;
	
						if (key === name) {
							break;
						}
					} catch (e) {}
				}
	
				return key ? jar[key] : jar;
			}
	
			api.set = set;
			api.get = function (key) {
				return get(key, false /* read as raw */);
			};
			api.getJSON = function (key) {
				return get(key, true /* read as json */);
			};
			api.remove = function (key, attributes) {
				set(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.defaults = {};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));


/***/ }),

/***/ 108:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(108);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var About = function About(_ref) {
	  var hideUX = _ref.hideUX;
	  return _react2.default.createElement(
	    'section',
	    { className: 'container mt-5 mb-5', id: 'about' },
	    _react2.default.createElement(
	      'div',
	      {
	        id: 'contact',
	        className: 'contact-links d-flex align-items-center justify-content-after'
	      },
	      _react2.default.createElement(
	        'a',
	        {
	          type: 'button',
	          className: 'btn btn-light mb-4 mb-sm-0 mr-4',
	          href: '/Matt Harris Resume.pdf',
	          target: '_blank'
	        },
	        'Resume'
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'mailto:matthewzharris@gmail.com', className: 'mr-4' },
	        'matthewzharris@gmail.com'
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.linkedin.com/in/matthewzharris/', target: '_blank' },
	        'linkedin'
	      )
	    )
	  );
	};
	
	About.defaultProps = {
	  hideUX: false
	};
	
	exports.default = About;
	module.exports = exports['default'];

/***/ }),

/***/ 286:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(286);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Experience = function Experience() {
	  return _react2.default.createElement(
	    'section',
	    { className: 'container mt-5 mb-5', id: 'experience' },
	    _react2.default.createElement(
	      'div',
	      { className: 'experience-grid' },
	      _react2.default.createElement(
	        'div',
	        { className: 'experience-column' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Experience'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'experience-list' },
	          _react2.default.createElement(
	            'div',
	            { className: 'experience-item' },
	            _react2.default.createElement(
	              'h5',
	              { className: 'experience-company' },
	              'Datadog'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'experience-title' },
	              'Product Design Manager // Senior Product Designer'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'experience-item' },
	            _react2.default.createElement(
	              'h5',
	              { className: 'experience-company' },
	              'NGINX'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'experience-title' },
	              'Product Design Manager // Senior Product Designer'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'experience-item' },
	            _react2.default.createElement(
	              'h5',
	              { className: 'experience-company' },
	              'New Engen'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'experience-title' },
	              'Product Designer'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'experience-item' },
	            _react2.default.createElement(
	              'h5',
	              { className: 'experience-company' },
	              'Freelance'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'experience-title' },
	              'Product Designer'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'selected-works-column' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Selected Works'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'selected-works-list' },
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.datadoghq.com/blog/manage-ai-cost-and-performance-with-datadog/', target: '_blank', rel: 'noopener noreferrer', className: 'selected-work-card' },
	            _react2.default.createElement('div', { className: 'selected-work-image', style: { backgroundImage: 'url(https://imgix.datadoghq.com/img/blog/manage-ai-cost-and-performance-with-datadog/datadog-ai-costs-hero.png?auto=format&fit=max&w=847)' } }),
	            _react2.default.createElement(
	              'span',
	              { className: 'selected-work-title' },
	              'Manage AI Cost and Performance'
	            )
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.datadoghq.com/blog/cloud-cost-management-finops/', target: '_blank', rel: 'noopener noreferrer', className: 'selected-work-card' },
	            _react2.default.createElement('div', { className: 'selected-work-image', style: { backgroundImage: 'url(https://imgix.datadoghq.com/img/blog/cloud-cost-management-finops/cloud-cost-management-finops-hero.png?auto=format&fit=max&w=847)' } }),
	            _react2.default.createElement(
	              'span',
	              { className: 'selected-work-title' },
	              'Cloud Cost Management for FinOps'
	            )
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.datadoghq.com/blog/cloud-cost-recommendations/', target: '_blank', rel: 'noopener noreferrer', className: 'selected-work-card' },
	            _react2.default.createElement('div', { className: 'selected-work-image', style: { backgroundImage: 'url(https://imgix.datadoghq.com/img/blog/cloud-cost-recommendations/cloud-cost-recommendations-hero.png?auto=format&fit=max&w=847)' } }),
	            _react2.default.createElement(
	              'span',
	              { className: 'selected-work-title' },
	              'Cloud Cost Recommendations'
	            )
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.datadoghq.com/blog/dashboards-notebooks-version-history/', target: '_blank', rel: 'noopener noreferrer', className: 'selected-work-card' },
	            _react2.default.createElement('div', { className: 'selected-work-image', style: { backgroundImage: 'url(https://imgix.datadoghq.com/img/blog/dashboards-notebooks-version-history/version-history_hero.png?auto=format&fit=max&w=847)' } }),
	            _react2.default.createElement(
	              'span',
	              { className: 'selected-work-title' },
	              'Dashboards & Notebooks Version History'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Experience;
	module.exports = exports['default'];

/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(77);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _WorkItem = __webpack_require__(13);
	
	var _WorkItem2 = _interopRequireDefault(_WorkItem);
	
	var _datadogLogo = __webpack_require__(116);
	
	var _datadogLogo2 = _interopRequireDefault(_datadogLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Work = function Work() {
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'section',
	      { className: 'container mb-5 pb-5', id: 'work' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'h5',
	          { className: 'col-sm' },
	          'Current Work'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row mb-4' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-6 mb-4 mb-md-0' },
	          _react2.default.createElement(_WorkItem2.default, { href: 'https://www.datadoghq.com/product/cloud-cost-management/', title: 'Cloud Cost Management', image: _datadogLogo2.default })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-6 mb-4 mb-md-0' },
	          _react2.default.createElement(_WorkItem2.default, { href: 'https://instances.datadoghq.com/', title: 'Instance Explorer', image: _datadogLogo2.default })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm' },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/past-work/', style: { color: 'rgba(255, 255, 255, 0.9)', textDecoration: 'none', fontSize: '1rem' } },
	            'View Past Work \u2192'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Work;
	module.exports = exports['default'];

/***/ }),

/***/ 22:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var PATH_PREFIX_COOKIE = exports.PATH_PREFIX_COOKIE = 'mzhpathprefix';

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/datadog-logo.feb3d97f.png";

/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/hero-image.0a325e21.jpg";

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jsCookie = __webpack_require__(27);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var _Hero = __webpack_require__(12);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Work = __webpack_require__(81);
	
	var _Work2 = _interopRequireDefault(_Work);
	
	var _Experience = __webpack_require__(163);
	
	var _Experience2 = _interopRequireDefault(_Experience);
	
	var _About = __webpack_require__(80);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _constants = __webpack_require__(22);
	
	var _heroImage = __webpack_require__(405);
	
	var _heroImage2 = _interopRequireDefault(_heroImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = function (_Component) {
	  _inherits(IndexPage, _Component);
	
	  function IndexPage() {
	    _classCallCheck(this, IndexPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  IndexPage.prototype.componentDidMount = function componentDidMount() {
	    _jsCookie2.default.set(_constants.PATH_PREFIX_COOKIE, '');
	  };
	
	  IndexPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _Hero2.default,
	        { portrait: _heroImage2.default, portraitAlt: 'Matt Harris presenting' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'stylized-name' },
	          _react2.default.createElement(
	            'span',
	            { className: 'name-matt' },
	            'Matt'
	          ),
	          ' ',
	          _react2.default.createElement(
	            'span',
	            { className: 'name-harris' },
	            'Harris'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'index-subtitle' },
	          'Product Design Manager based in San Francisco working at',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://datadoghq.com/', target: '_blank' },
	            'Datadog'
	          ),
	          '.'
	        )
	      ),
	      _react2.default.createElement(_Work2.default, null),
	      _react2.default.createElement(_Experience2.default, null),
	      _react2.default.createElement(_About2.default, null)
	    );
	  };
	
	  return IndexPage;
	}(_react.Component);
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-9a48d45f57730fb82609.js